import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { ResultsComponent } from "../../Components/ResultComponent/ResultComponent";

export const Results = () => {
  return (
    <Wrapper header="Results">
      <ResultsComponent />
    </Wrapper>
  );
};
